import * as eff from 'redux-saga/effects';

import initialize from './initialize';
import {
  takeLoadFilterOptionsRequest,
  takeFetchFilterResourcesByIdRequest,
} from './filters';
import {
  listenFetchIssues,
  takeLoadSelectIssuesOptionsRequest,
} from './issues';
import {
  takeDeleteWorklogRequest,
  takeSaveWorklogRequest,
} from './worklogs';


export default function* rootSaga() {
  yield eff.all([
    eff.fork(listenFetchIssues),
    eff.fork(takeLoadFilterOptionsRequest),
    eff.fork(takeFetchFilterResourcesByIdRequest),
    eff.fork(takeDeleteWorklogRequest),
    eff.fork(takeSaveWorklogRequest),
    eff.fork(takeLoadSelectIssuesOptionsRequest),
    eff.fork(initialize),
  ]);
}
